import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const generateSessionId = function () {
	return Math.floor(100000 + Math.random() * 900000);
};
const initialState = {
	email: "",
	authToken: "",
	name: "",
	roles: null,
	isLoggedIn: false,
	id: "",
	sessionId: generateSessionId(),
	features: [],
	allPossibleRoles: [],
};
export default function userInfo(state, action) {
	if (typeof state === "undefined") {
		return initialState;
	}

	let newState = null;

	switch (action.type) {
		case actionTypes.LOGIN_USER:
			newState = objectAssign({}, state, action.payload);
			newState.isLoggedIn = true;
			return newState;
		case actionTypes.UPDATE_USER:
			newState = objectAssign({}, state, action.payload);
			return newState;
		case actionTypes.LOGOUT_USER:
			newState = objectAssign({}, initialState);
			return newState;
		case actionTypes.GENERATE_NEW_SESSION_ID:
			newState = objectAssign({}, state);
			newState.sessionId = generateSessionId();
			return newState;
		case actionTypes.SET_USER_FEATURE:
			newState = objectAssign({}, state, { features: action.payload });
			return newState;
		case actionTypes.SET_ALL_ROLES:
			newState = objectAssign({}, state, { allPossibleRoles: action.payload });
			return newState;
	}
	return state;
}
